import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import TextUnderline from '@components/TextUnderline';
import colors from '@constants/colors';
import { CouponRow } from '@models/coupon';
import { Link } from '@router/Link';
import dayjs from 'dayjs';

import DownloadIcon from './DownloadIcon';
import img from './img.png';
import styles from './styles.module.scss';

interface Props {
    coupon:CouponRow;
    downloadAble?: boolean;
    isHistory?: boolean;
}

function CouponItem({ coupon, downloadAble, isHistory }:Props) {
  const {
    expiresAt, availableShops, couponName, imageUrl, status, couponId,
  } = coupon;
  const leftDays = dayjs(expiresAt).diff(dayjs(), 'day');
  const headerText = (() => {
    switch (status) {
      case 'USED': return '사용 완료';
      case 'EXPIRED': return '기간 만료';
      case 'CANCELLED': return '발급 취소';
      default: return `${leftDays}일 남음`;
    }
  })();

  return (
        <Link activityName='CouponDetailActivity'
              activityParams={{ couponId }}
              style={{ width: '100%' }}>
            <Row fullWidth spacing={16} align='flex-start'
                 className={styles.container} >
                <div className={styles.itemImage}>
                    <Image src={imageUrl}
                           alt={couponName}
                           width={80}
                           height={80} />
                </div>
                <Column spacing={4}>
                    <Text size='s'>{availableShops}</Text>
                    <Text size='lg' fontWeight='medium'>{couponName}</Text>
                    <Row spacing={8}>
                        {(!isHistory) && (
                            <div className={styles.badge}>
                                <Text size='xs' color={colors.gray8} fontWeight='semibold'>
                                    {headerText}
                                </Text>
                            </div>
                        )}
                        <Text color={colors.gray7} size='s'>
                            유효기간 {dayjs(expiresAt).format('YYYY.MM.DD')}
                        </Text>
                        {(isHistory) && (
                            <div className={styles.badge}>
                                <Text size='xs' color={colors.gray8} fontWeight='semibold'>
                                    {headerText}
                                </Text>
                            </div>
                        )}
                    </Row>
                </Column>
                {downloadAble && (
                    <button className={styles.download} >
                        <DownloadIcon />
                    </button>
                )}
            </Row>
        </Link>
  );
}

export default CouponItem;
